import Sticky from 'node_modules/sticky-js/dist/sticky.min.js';

$(document).ready( function() {

    new Sticky('.quick-navigation:not(.quick-navigation--with-container)', {stickyContainer: '.page__footer', marginTop: 70, stickyFor: 1200});

    $('#quick-navigation_list a').on('click', function() {
        let id = $(this).attr('href');
        if ($(id).length) {
            $('html,body').animate({scrollTop: $(id).offset().top - 100}, 'slow');
        }
    });

    $(window).scroll(function(e) {
        let scroll = $(window).scrollTop();
          
        $('#quick-navigation_list .active').removeClass('active');

        let $lastElement = null;

        $('[id^="chapter_"]').each(function(_, chapter) {
            let id = chapter.id;
  
            if($(chapter).offset().top <= scroll) {
                $lastElement = $('#quick-navigation_list a[href=\'#' + id + '\']');
            }
        });

        if ($lastElement) {
            $lastElement.addClass('active')
        }

     });

});
